import React, { PropsWithChildren } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import { withSentryHub } from './sentry';

export interface SentryBoundaryProps extends PropsWithChildren {
    componentId?: string;
    fallbackRender?: (props: FallbackProps) => React.ReactElement | null;
}

export const SentryBoundary: React.FC<SentryBoundaryProps> = ({
    children,
    componentId = 'unknown-component',
    fallbackRender,
}) => {
    const defaultFallback = () => (
        <div data-zta={`sentry-error-boundary-${componentId}`} />
    );

    return (
        <ErrorBoundary
            fallbackRender={fallbackRender || defaultFallback}
            onError={(error) => withSentryHub()?.captureException(error)}>
            {children}
        </ErrorBoundary>
    );
};
